/**
 * Hook que observa el estado del streaming en tiempo real
 * Se sincroniza con el servidor vía Socket.io (broadcast-live, broadcast-ended)
 */
import { useState, useEffect } from 'react';
import { streamingObservable } from '../services/streamingObservable';

export function useStreamingStatus(options = {}) {
  const { autoWatch = true } = options;
  const [status, setStatus] = useState(streamingObservable.getState());

  useEffect(() => {
    const unsubscribe = streamingObservable.subscribe(setStatus);
    if (autoWatch) {
      streamingObservable.watch();
    }
    return () => {
      unsubscribe();
      if (autoWatch) {
        streamingObservable.unwatch();
      }
    };
  }, [autoWatch]);

  return status;
}
